import { Box, IconButton, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBlock: theme.spacing(1),
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[900],
}));

export const StyledFileInfoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.grey[900],
}));

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingInline: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.spacing(0.5),
}));

export const StyledFileName = styled(Typography)({
  fontSize: 12,
  fontWeight: 700,
});

export const StyledFileSize = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  color: theme.palette.grey[500],
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[900],
}));
